document.addEventListener('DOMContentLoaded', () => {
  const editorialGalleries = document.querySelectorAll('product-gallery[desktop-layout="editorial"]');

  const forcePlayNativeVideos = (root = document) => {
    const videos = root.querySelectorAll('.js-product-gallery-autoplay-video');

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.autoplay = true;

      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('preload', 'auto');

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    });
  };

  editorialGalleries.forEach((gallery) => {
    const showMoreWrapper = gallery.querySelector('.product-gallery__show-more-wrapper');
    const showMoreBtn = gallery.querySelector('.product-gallery__show-more-btn');

    if (showMoreWrapper && showMoreBtn) {
      showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const isCollapsed = gallery.classList.contains('is-collapsed');

        if (isCollapsed) {
          gallery.classList.remove('is-collapsed');
          showMoreBtn.setAttribute('aria-expanded', 'true');
        } else {
          gallery.classList.add('is-collapsed');
          showMoreBtn.setAttribute('aria-expanded', 'false');

          gallery.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }

        window.dispatchEvent(new Event('resize'));

        setTimeout(() => {
          forcePlayNativeVideos(gallery);
        }, 100);
      });
    }

    forcePlayNativeVideos(gallery);
  });

  setTimeout(() => forcePlayNativeVideos(document), 250);
  setTimeout(() => forcePlayNativeVideos(document), 800);
  setTimeout(() => forcePlayNativeVideos(document), 1600);

  document.addEventListener('variant:change', () => {
    setTimeout(() => forcePlayNativeVideos(document), 400);
  });

  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => forcePlayNativeVideos(document), 400);
  });

  window.addEventListener('load', () => {
    forcePlayNativeVideos(document);
  });
});